import { isEmpty, splitList, STUDY_STATUS_OPTIONS, STUDY_TYPE_OPTIONS, yesNo } from "../../quick-filter/ExtraFilters";

/**
 * Çekim grid'inin "Diğer filtreler" alanları — çubukta kendi düğmesi olmayan, sol panelde (StudyFilter) duran
 * filtreler. Alan tanımının biçimi: bkz. quick-filter/ExtraFilters. Sıra paneldeki sıradır.
 */
export const STUDY_EXTRA_FIELDS = [
    { key: 'hospitalGroupIdList', label: 'Hospital Groups', kind: 'lookup', source: 'hospitalGroups', empty: [], permissions: ['HOSPITAL_GROUP_FILTER'] },
    { key: 'hospitalIdList', label: 'Hospitals', kind: 'lookup', source: 'hospitals', empty: [] },
    {
        key: 'patientId',
        label: 'Patient Id',
        kind: 'list',
        empty: undefined,
        // Sol panel metni patientId'de, sunucuya giden diziyi patientIdList'te tutar (bkz. StudyFilter.filter).
        isActive: (filter) => !isEmpty(filter.patientIdList) || !isEmpty(`${filter.patientId ?? ''}`.trim()),
        toDraft: (filter) => (!isEmpty(filter.patientIdList) ? filter.patientIdList.join(', ') : (filter.patientId ?? '')),
        toFilter: (value) => {
            const items = splitList(value);
            return { patientId: items.length ? items.join(', ') : undefined, patientIdList: items };
        },
        clearChanges: { patientId: undefined, patientIdList: [] },
    },
    { key: 'patientName', label: 'Patient Name', kind: 'text', empty: undefined },
    { key: 'accessionNumber', label: 'Accession No', kind: 'text', empty: undefined },
    { key: 'idList', label: 'Study Id List', kind: 'list', empty: [] },
    { key: 'studyInstanceUIDList', label: 'Study UID', kind: 'list', empty: [] },
    {
        key: 'listIdList',
        label: 'Lists',
        kind: 'lookup',
        source: 'lists',
        empty: null,
        permissions: ['LIST_VIEW', 'LIST_VIEW_ALL', 'LIST_CREATE', 'LIST_ITEM_ADD'],
        // Liste filtresinde boş dizi "imkânsız sonuç" demek (bkz. study-filter-query) → null.
        toFilter: (value) => ({ listIdList: value?.length ? value : null }),
    },
    { key: 'institutions', label: 'Institution', kind: 'lookup', source: 'institutions', empty: [], permissions: ['VIEW_STUDY_INSTITUTION'] },
    { key: 'studyTypeList', label: 'Study Type', kind: 'select', multiple: true, options: STUDY_TYPE_OPTIONS, empty: [], work: true },
    { key: 'studyStatus', label: 'Study Status', kind: 'select', multiple: true, options: STUDY_STATUS_OPTIONS, empty: [], work: true },
    { key: 'isRead', label: 'Is Read', kind: 'select', options: yesNo('Read', 'Not Read'), empty: null, work: true },
    { key: 'assignDoctor', label: 'Assigned (Doctor)', kind: 'assign', source: 'readableUsers', pickPermission: 'STUDY_ASSIGN_DOCTOR_USER', empty: null, work: true, permissions: ['STUDY_SET_READ'] },
    { key: 'assignReporter', label: 'Assigned (Reporter)', kind: 'assign', source: 'writableUsers', pickPermission: 'STUDY_ASSIGN_REPORTER_USER', empty: null, work: true, permissions: ['REPORT_ADD_OR_EDIT'] },
    { key: 'readUserId', label: 'Read User', kind: 'user', source: 'readableUsers', userType: 'read', empty: undefined },
    { key: 'writeUserId', label: 'Wrote User', kind: 'user', source: 'writableUsers', userType: 'write', empty: undefined },
    { key: 'isReportable', label: 'Is Reportable', kind: 'select', options: yesNo('Reportable', 'Not Reportable'), empty: true, permissions: ['SET_STUDY_REPORTABLE'] },
    { key: 'hasOpenTask', label: 'Open Task', kind: 'select', options: yesNo('Has Open Task', 'No Task'), empty: null },
    { key: 'hasAiDicom', label: 'AI Dicom', kind: 'select', options: yesNo('TRUE', 'FALSE'), empty: null },
    { key: 'isDeleted', label: 'Is Deleted', kind: 'select', options: yesNo('Deleted', 'Not Deleted'), empty: false, permissions: ['STUDY_LIST_DELETED'] },
    {
        key: 'hl7FilterType',
        label: 'HL7 Filter',
        kind: 'select',
        options: [{ value: 1, label: 'HAS_NO_HL7_MESSAGE' }],
        empty: undefined,
        isActive: (filter) => !!filter.hl7FilterType,   // 0 = "Tümü"
    },
];
